import { render, staticRenderFns } from "./servicerRegularEidt.vue?vue&type=template&id=5fb34164&scoped=true"
import script from "./servicerRegularEidt.vue?vue&type=script&lang=js"
export * from "./servicerRegularEidt.vue?vue&type=script&lang=js"
import style0 from "./servicerRegularEidt.vue?vue&type=style&index=0&id=5fb34164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb34164",
  null
  
)

export default component.exports